import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerRightUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-corner-right-up"} maskId="square-filled-radius-0-stroke-1-IconArrowCornerRightUp"><path fillRule="evenodd" clipRule="evenodd" d="M4 20.0001H14.5V4.70718L10.5 8.70718L9.79289 8.00008L15 2.79297L20.2071 8.00008L19.5 8.70718L15.5 4.70718V21.0001H4V20.0001Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowCornerRightUp;
